import { CommonHelperFunctions, IScheduledJobsDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class ScheduledJobsService {
  public static async Create(screenDesignDocument: IScheduledJobsDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IScheduledJobsDto, AxiosResponse>(
        `${backendUrl}/scheduledJobs/create`,
        screenDesignDocument
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Update(id: string, obj: IScheduledJobsDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<IScheduledJobsDto, AxiosResponse>(`${backendUrl}/scheduledJobs/update/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/scheduledJobs/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async Get(id: string): Promise<AxiosResponse<IScheduledJobsDto>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/scheduledJobs/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetAllByProjectId(id: string): Promise<AxiosResponse<IScheduledJobsDto[]>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/scheduledJobs/getallbyprojectid/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Inactivate(id: string): Promise<boolean> {
    try {
      await Axios.post<null>(`${backendUrl}/scheduledJobs/inactive/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async Activate(id: string): Promise<boolean> {
    try {
      await Axios.post<null>(`${backendUrl}/scheduledJobs/activate/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }
}
